import { render } from "./NewsContacts.vue?vue&type=template&id=ebc5e792"
import script from "./NewsContacts.vue?vue&type=script&lang=js"
export * from "./NewsContacts.vue?vue&type=script&lang=js"

import "./NewsContacts.vue?vue&type=style&index=0&id=ebc5e792&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__